import React from 'react'
import PropTypes from 'prop-types'

import concat from 'lodash/concat'
import fill from 'lodash/fill'

import { Container, Dot, RowWrapper } from './styles'

function Dots({
  rows,
  columns,
  margin = '14px',
  corners = [true, true, true, true],
  primary = false,
  secondary = false,
}) {
  const grid = []
  grid.push(concat(corners?.[0], fill(Array(columns - 2), true), corners?.[1]))

  for (let i = 0; i < rows - 2; i += 1) {
    grid.push(fill(Array(columns), true))
  }
  grid.push(concat(corners?.[2], fill(Array(columns - 2), true), corners?.[3]))

  return (
    <Container>
      {grid.map((line, index) => {
        const key = index + 1
        return (
          <RowWrapper key={key} mb={margin}>
            {line.map((point, index_point) => {
              const key_point = index_point + 1
              return point ? (
                <Dot
                  key={key_point}
                  mr={margin}
                  primary={primary}
                  secondary={secondary}
                />
              ) : (
                <Dot key={key_point} mr={margin} transparent />
              )
            })}
          </RowWrapper>
        )
      })}
    </Container>
  )
}

Dots.defaultProps = {
  corners: [true, true, true, true],
  margin: 14,
  primary: false,
  secondary: false,
}

Dots.propTypes = {
  columns: PropTypes.number.isRequired,
  corners: PropTypes.array,
  margin: PropTypes.number,
  primary: PropTypes.bool,
  rows: PropTypes.number.isRequired,
  secondary: PropTypes.bool,
}

export default Dots
